import React, { createContext, useContext, useState } from "react";
const AllStateContext = createContext();
function StateManagment({ children }) {
  const [shownav, setShownav] = useState(false);
  const [showwelcomepage, setShowwelcomepage] = useState(true);
  const [image, setImage] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [showeditcom, setShoweditcom] = useState(false);
  const [showeditstudent, setShoweditstudentcom] = useState(false);
  const [showeditteacher, setShoweditteachercom] = useState(false);
  function changewelcomepage() {
    setShowwelcomepage(false);
  }
  function handleShownav() {
    setShownav((prev) => !prev);
  }
  return (
    <AllStateContext.Provider
      value={{
        shownav,
        handleShownav,
        changewelcomepage,
        image,
        setImage,
        lastName,
        setLastName,
        firstName,
        setFirstName,
        showeditcom,
        setShoweditcom,
        showeditstudent,
        setShoweditstudentcom,
        showeditteacher,
        setShoweditteachercom,
        showwelcomepage,
        setShowwelcomepage,
        setShownav,
      }}
    >
      {children}
    </AllStateContext.Provider>
  );
}
function UseAllState() {
  return useContext(AllStateContext);
}
export { StateManagment, UseAllState };

